import { render } from "./Factions.vue?vue&type=template&id=be751a12&scoped=true"
import script from "./Factions.vue?vue&type=script&lang=js"
export * from "./Factions.vue?vue&type=script&lang=js"

import "./Factions.vue?vue&type=style&index=0&id=be751a12&scoped=true&lang=css"

import exportComponent from "E:\\work\\copy\\work\\fa\\tgkw\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be751a12"]])

export default __exports__